import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const PurchaseCredits = async (domain: string, creditPlanId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `credits`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        params: { creditPlanId }
    });
}